<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateKnowledgeBaseDocument"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Add Document to Knowledge Base</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Document Category</label>

              <select
                name=""
                id=""
                class="p-2 bg-gray-200 rounded-full w-full"
                v-model="info.KnowledgebaseCategoryId"
                required
              >
                <option value="" default selected>Select Category</option>
                <option
                  v-for="category in categories"
                  :value="category.Id"
                  :key="category.Id"
                >
                  {{ category.Name }}
                </option>
              </select>
            </div>
          </div>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                class="overflow-hidden form-control block w-full px-3 p-2 bg-gray-200 rounded-md py-1.5 text-base font-normal text-gray-700 bg-clip-padding border border-solid border-gray-300 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none border-0.5"
                id="description"
                rows="3"
                placeholder="Add document description"
                style="background-color: #f3f3f3"
                required
                maxlength="100"
                v-model="info.Description"
              ></textarea>
            </div>
          </div>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <input
                v-on:change="getFile"
                type="file"
                accept="application/pdf"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
              <small class="text-xs text-red-400">Pdf files only</small>
            </div>
          </div>

          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "CompanySetupCreateKnowledgeDocs",
  props: ["showCreateKnowledgeBaseDocument", "reload"],
  components: { Loader },
  data() {
    return {
      info: {
        KnowledgebaseCategoryId: "",
        Attachment: "",
        Description: "",
      },
      fileList: [],
      create_error: null,
      create_success: null,
      loading: false,
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },

  created() {
    this.getCategory();
  },
  methods: {
    getFile({ target }) {
      const file = target.files[0];
      this.info.Attachment = file;
    },
    close() {
      this.$emit("close");
    },

    // /{organization}/setup/document/type/v1/create
    create() {
      // console.log(this.fileList);
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      };

      const formData = new FormData();
      formData.append(
        "KnowledgebaseCategoryId",
        this.info.KnowledgebaseCategoryId
      );
      formData.append("Attachment", this.info.Attachment);

      formData.append("Description", this.info.Description);

      // /{organization}/company/knowledgebase/v1/create
      axios
        .post(
          `${this.getOrganization}/company/knowledgebase/${this.$ApiVersion}/create`,
          formData,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.create_success = response.data.StatusMessage;
              this.info = {
                KnowledgebaseCategoryId: "",
                Attachment: "",
                Description: "",
              };

              setTimeout(() => {
                this.create_success = null;
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },

    // /{organization}/setup/knowledgebase/category/v1/request
    getCategory() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      this.info.DocumentClassification = parseInt(
        this.info.DocumentClassification
      );
      axios
        .get(
          `${this.getOrganization}/setup/knowledgebase/category/${this.$ApiVersion}/request`,

          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.categories = response.data.Data;

              setTimeout(() => {
                this.create_success = null;
                this.reload();
              }, 2500);
            } else {
              this.create_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.create_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
